import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/api/v1/admin/members/account_management/list',
    method: 'post',
    mock: false,
    data,
  })
}

// 获取会员支付方式列表
export function getPaymentMethodList(data) {
  return request({
    url: '/api/v1/admin/members/account_management/list',
    method: 'post',
    mock: false,
    data,
  })
}

// 新增会员支付方式
export function addPaymentMethod(data) {
  return request({
    url: '/api/v1/admin/members/account_management/create',
    method: 'post',
    mock: false,
    data,
  })
}

// 编辑会员支付方式
export function editPaymentMethod(data) {
  return request({
    url: '/api/v1/admin/members/account_management/update',
    method: 'post',
    mock: false,
    data,
  })
}

// 删除会员支付方式
export function deletePaymentMethod(data) {
  return request({
    url: '/api/v1/admin/members/account_management/delete',
    method: 'post',
    mock: false,
    data,
  })
}

// 查询用户是否存在
export function checkUserExists(data) {
  return request({
    url: '/api/v1/admin/members/get_member',
    method: 'post',
    mock: false,
    data,
  })
}

// 获取银行名称列表（占位接口）
// 接口格式示例：
// {
//   "AB MICROFINANCE BANK": "ABK",
//   "ABBEY MORTGAGE BANK": "ABB"
// }
export function getBankNameMap(data) {
  return request({
    url: '/api/v1/admin/members/account_management/get_payout_bank_list',
    method: 'post',
    mock: false,
    data,
  })
}

// 禁用玩家
// {
//   "disable_desc": "string",
//   "uid": 0
// }
export function disableMember(data) {
  return request({
    url: '/api/v1/admin/members/member_list/modify/disable_player',
    method: 'post',
    mock: false,
    data,
  })
}

// 启用玩家
// {
//   "enable_desc": "string",
//   "uid": 0
// }
export function enableMember(data) {
  return request({
    url: '/api/v1/admin/members/member_list/modify/enable_player',
    method: 'post',
    mock: false,
    data,
  })
}

// 获取会员禁用启用历史日志
// {
//   "uid": 0
// }
export function getMemberDisableEnableLog(data) {
  return request({
    url: '/api/v1/admin/members/member_list/disable_enable_player_logs',
    method: 'post',
    mock: false,
    data,
  })
}
